// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3lJkZ","content":"Consent_content__zn0IP","footer":"Consent_footer__2b7Z0"};